'use client';

import { c as _c } from "react/compiler-runtime";
import AnimateLines from '@components/animate-lines/AnimateLines';
import HorizontalScroll from '@components/horizontal-scroll/HorizontalScroll';
import SliderHand from '@components/slider-hand/SliderHand';
import VideoButton from '@components/video-button/VideoButton';
import { ScrollTrigger } from '@lib/tools/gsap-init';
import { useEffect, useLayoutEffect, useRef, useState } from 'react';
import style from './HappinessInMoment.module.scss';
function HappinessInMoment(t0) {
  const $ = _c(27);
  const {
    sliderData,
    isMobile,
    isTablet
  } = t0;
  const [toggle, setToggle] = useState(false);
  const [st18, setSt18] = useState(null);
  const svgRef = useRef(null);
  let t1;
  let t2;
  if ($[0] !== isMobile) {
    t1 = () => {
      let timer;
      if (svgRef.current) {
        const element = svgRef.current;
        const initScrollTrigger = () => {
          const trigger = ScrollTrigger.create({
            trigger: element,
            id: "fall",
            start: "top center",
            scroller: !isMobile ? "#smooth-wrapper" : "body",
            scrub: true,
            pin: false,
            onToggle: () => {
              setToggle(true);
            }
          });
          setSt18(trigger);
        };
        timer = setTimeout(() => {
          requestAnimationFrame(() => {
            requestAnimationFrame(initScrollTrigger);
          });
        }, 1000);
      }
      return () => clearTimeout(timer);
    };
    t2 = [svgRef, isMobile];
    $[0] = isMobile;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useLayoutEffect(t1, t2);
  let t3;
  if ($[3] !== st18) {
    t3 = () => () => {
      if (st18) {
        st18.kill();
      }
      setSt18(null);
      ScrollTrigger.getById("fall")?.kill();
    };
    $[3] = st18;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = [];
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  useEffect(t3, t4);
  let t5;
  if ($[6] !== isMobile || $[7] !== toggle) {
    t5 = !isMobile && <div className={style.fourthScreenSvg_one}><AnimateLines id="vector_10" className={style.svgClass} toggle={toggle} /></div>;
    $[6] = isMobile;
    $[7] = toggle;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <br />;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <div className={style.fourthScreenTextBox}><div data-scroll={true} data-scroll-speed="0.5" className={style.fourthScreenTitle}>Жизнь, {t6} где счастье <br /> в моменте</div><div data-scroll={true} data-scroll-speed="0.5" className={style.fourthScreenDescription}>Моментс живописно рисует свою картину мира посреди городской жизни. Неповторимая атмосфера экоквартала создаёт все условия для погружения в личный микрокосмос.{" "}</div><VideoButton video="feel" black={true} /></div>;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  const t8 = !isMobile ? "vector_11" : "vector_6_mob";
  let t9;
  if ($[11] !== t8 || $[12] !== toggle) {
    t9 = <div className={style.fourthScreenSvg_two}><AnimateLines id={t8} className={style.svgClass} toggle={toggle} /></div>;
    $[11] = t8;
    $[12] = toggle;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== t5 || $[15] !== t9) {
    t10 = <div className={style.fourthScreenWrapper}>{t5}{t7}{t9}</div>;
    $[14] = t5;
    $[15] = t9;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  const t11 = !(isMobile || isTablet);
  let t12;
  if ($[17] !== t11) {
    t12 = <SliderHand orientation="right" hidden={t11} />;
    $[17] = t11;
    $[18] = t12;
  } else {
    t12 = $[18];
  }
  let t13;
  if ($[19] !== isMobile || $[20] !== isTablet || $[21] !== sliderData) {
    t13 = <HorizontalScroll sliderData={sliderData} isMobile={isMobile} isTablet={isTablet} />;
    $[19] = isMobile;
    $[20] = isTablet;
    $[21] = sliderData;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  let t14;
  if ($[23] !== t10 || $[24] !== t12 || $[25] !== t13) {
    t14 = <div ref={svgRef} data-scroll={true} className={style.fourthScreenContainer}>{t10}{t12}{t13}</div>;
    $[23] = t10;
    $[24] = t12;
    $[25] = t13;
    $[26] = t14;
  } else {
    t14 = $[26];
  }
  return t14;
}
export default HappinessInMoment;